export class Identity {
  public email?: string;
  public roles?: string[];
}
